import appStore from "store";
import api from "./api";

const store = {
  namespaced: true,
  state: {
    robotlist: [],
    pairData:[],
    updatePosterDialog: false,
    totalCount: 0,
  },
  getters: {
    //  filterList:state=>state.robotlist
  },
  mutations: {
    setrobotlist(state, payload) {
      state.robotlist = payload.list;
    },
    setPairData(state, payload) {
      state.pairData = payload
    },
    setupdatePosterDialog(state, payload) {
      state.updatePosterDialog = payload;
    },
    setTotalCount(state, payload) {
      state.totalCount = payload;
    },
    pageChanged(state, payload) {},
  },
  actions: {
   async getList({commit},{page,size,robotId}){
      const res=await api.getList({page,size,robotId})
      commit('setrobotlist',res.data)
      commit("setTotalCount", res.data.totalCount);
      return res
    },

   async getPairData({commit}){
      const res=await api.getPairData()
      commit('setPairData',res.data)
    },
    async updateOne({commit},data){
      const res=await api.updateOne(data)
      return res 
    },
    async addOne({commit},data){
      const res=await api.addOne({...data})
      return res
    },
    async delOne({commit},id){

      const res=await api.delOne(id)
      return res
    },




  }
};

appStore.registerModule("RobotPairConfig", store);
